<div class="ui-g page-header-c">
    <div class="ui-g-12 ui-md-6 ui-lg-6">
        <span class="backbtn" (click)="goBack()"><i class="fa fa-arrow-left"></i></span>
        <span *ngIf="!isDeleteCheckboxSelected" translate class="page-headers">label_teams_add_details</span>
        <span *ngIf="isDeleteCheckboxSelected" translate class="page-headers">label_teams_delete_details</span>
        <span class="page-title"> {{firstName}} {{lastName}}</span>

    </div>
</div>
<div class="ui-g form-container containar-layout shift-planning-section">
    <div class="ui-g-12">
        <div class="ui-g pb-20">
            <div class="ui-g-12  ui-md-12 ui-lg-12 add-shift">
                <div class="ui-g add-shift">
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_end_on</label>
                        </div>
                        <div class="form-control-c">
                            <p-dropdown [style]="{'width': '100%'}" [options]="endsOnTableList"
                                [(ngModel)]="endDateTimeStr" (onChange)="onShiftChange($event)">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_start_date</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [defaultDate]="maxDate" [minDate]="minDate" dateFormat="{{dateFormat}}"
                                [showIcon]="true" [placeholder]="'label_shift_start_date' | translate"
                                [(ngModel)]="endDateTimeS" (click)="onStartDateClick(endDateTimeS)"></p-calendar>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_end_date</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [defaultDate]="maxDate" [minDate]="maxDate" dateFormat="{{dateFormat}}"
                                [showIcon]="true" [placeholder]="'label_shift_end_date' | translate" [minDate]="maxDate"
                                [(ngModel)]="endDateTimeSe" [disabled]="endDateTimeStr === 'never'"></p-calendar>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3 switch-btn">
                        <div class="form-control-c">
                            <p-inputSwitch class="switch-space"
                                (onChange)="onDeleteSelected($event.checked)"></p-inputSwitch>
                            <label for="providerName" translate>label_delete_shift_schedule</label>
                        </div>
                    </div>
                </div>

                <div class="ui-g add-shift">
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_weekly_allocationp</label>
                        </div>
                        <div class="circle-checkbox nowrap">
                            <label *ngFor="let objCheckbox of daysList; let i=index">
                                <input type="checkbox" name="chk{{ri}}" value="weeklyAllocationData[i].id"
                                    (change)="allocationListData($event, i)">
                                <span class="checkmark"><span class="chk-pos" translate>{{
                                        objCheckbox.displayValue }}</span></span>
                            </label>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_start_time</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12" [(ngModel)]="startTimeStr"
                                [placeholder]="'label_shift_start_time' | translate" [defaultDate]="currentDate"
                                (onBlur)="getTime(startTimeStr)" required
                                [disabled]="isDeleteCheckboxSelected"></p-calendar>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3">
                        <div class="form-label">
                            <label for="providerName" translate>label_shift_end_time</label>
                        </div>
                        <div class="form-control-c">
                            <p-calendar [timeOnly]="true" [stepMinute]="15" hourFormat="12" [(ngModel)]="endTimeStr"
                                [placeholder]="'label_shift_end_time' | translate" [defaultDate]="currentDate"
                                (onBlur)="getEndTime(endTimeStr)" required
                                [disabled]="isDeleteCheckboxSelected"></p-calendar>
                        </div>
                    </div>
                    <div class="form-field ui-g-12 ui-md-3 ui-lg-3"
                        *ngIf="!isDeleteCheckboxSelected && (userType === 'Mobile')">
                        <div class="form-label">
                            <label for="providerName" translate>label_team_name</label>
                        </div>
                        <div>
                            <p-dropdown class="disabled-bg1" [style]="{'width': '100%'}" [options]="teamList"
                                [(ngModel)]="selectedTeamList" [placeholder]="'label_team_name' | translate">
                            </p-dropdown>
                        </div>
                    </div>
                </div>

                <div class="ui-g-12 shift-schedule-note" *ngIf="!isDeleteCheckboxSelected">
                    <span translate>label_shift_schedule_operation_note</span>
                </div>
            </div>

        </div>
    </div>

    <div class="form-buttons ui-g-12 pt-20 mrg-top">
    <div *ngIf="isPTOEnable">
        <p-checkbox *ngIf="isDeleteCheckboxSelected"
            class="check ml-10" (onChange)="onPtoSelected($event)">
        </p-checkbox>
        <label *ngIf="isDeleteCheckboxSelected" class="check check-label">Do
            you want to remove PTO with schedule? </label>
    </div>

        <button *ngIf="isDeleteCheckboxSelected" class="save-btn" pButton type="button" [label]="'Delete' | translate"
            (click)="onDeleteMember()"
            [disabled]="!allocationListStr || !endDateTimeStr || ( endDateTimeStr === 'never' && !endDateTimeS)  || ( endDateTimeStr === 'custom' && !endDateTimeS)  || ( endDateTimeStr === 'custom' && !endDateTimeSe)"></button>
        <button *ngIf="!isDeleteCheckboxSelected" class="save-btn" pButton type="button" [label]="'Save' | translate"
            (click)="onBulkScheduleSave()"
            [disabled]="!allocationListStr || !startTimeStr || !endTimeStr || !endDateTimeStr || ( endDateTimeStr === 'never' && !endDateTimeS) || ( endDateTimeStr === 'custom' && !endDateTimeS)|| ( endDateTimeStr === 'custom' && !endDateTimeSe)"></button>
        <button class="cancel-btn" pButton type="button" [label]="'Cancel' | translate" (click)="cancelBut()"></button>
    </div>
</div>


<!--<p-confirmDialog header="Confirmation" icon="fa fa-question-circle"></p-confirmDialog>-->

<p-dialog [blockScroll]="true" header="Add New Member" modal="true" [showHeader]="true" styleClass="edit-profile-popup"
    [style]="{width: '500px'}" responsive="true" [(visible)]="showDialog" (onHide)="onHideDialog()">
    <div class="ui-g form-container">

        <div class="ui-g-12">
            <div class="ui-g-12 ui-md-12 ui-sm-12">
                <div class="dialog-text">
                    <p>Would you like to override the existing shift schedule or adjust it?</p>
                </div>
                <div class="mt-20 dialog-text">
                    <p> <span> Overriding </span> the shift will remove the existing shifts and the newly applicable
                        shift will come in effect.</p>
                </div>
                <div class="mt-20 dialog-text">
                    <p><span> Adjusting </span> the shift will either merge the shift if it is overlapping and if not,
                        then system will maintain the existing shift and add the newly applicable shift.</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-g-nopad form-buttons">
            <div class="page-buttons mt-30">
                <button pButton type="button" [label]="labelOverride" (click)="setOverrideValue()"></button>
            </div>
            <div class="adjust-btn mt-30">
                <button pButton type="button" [label]="labelAdjust" (click)="setAdjustValue()"></button>
            </div>
        </div>
    </div>
</p-dialog>


<p-dialog [blockScroll]="true" header="Delete Shift Schedule" modal="true" [showHeader]="true"
    styleClass="edit-profile-popup" [style]="{width: '350px'}" responsive="true" [(visible)]="showWithoutPtoDialog"
    (onHide)="onHideWithoutPtoDialog()">
    <div class="ui-g form-container">

        <div>
            <div class="ui-g-12 ui-md-12 ui-sm-12">
                <div class="dialog-text">
                    <p>Are you sure you want to delete only shift schedule?</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-g-nopad form-buttons">
            <div class="page-buttons mt-30">
                <button pButton type="button" [label]="labelYes" (click)="onDelete()"></button>
            </div>
            <div class="adjust-btn mt-30">
                <button pButton type="button" [label]="labelNo" (click)="onCancel()"></button>
            </div>
        </div>
    </div>
</p-dialog>


<p-dialog [blockScroll]="true" header="Delete Shift Schedule" modal="true" [showHeader]="true"
    styleClass="edit-profile-popup" [style]="{width: '350px'}" responsive="true" [(visible)]="showWithPtoDialog"
    (onHide)="onHideWithPtoDialog()">
    <div class="ui-g form-container">

        <div>
            <div class="ui-g-12 ui-md-12 ui-sm-12">
                <div class="dialog-text">
                    <p>Are you sure you want to delete shift schedule with PTO?</p>
                </div>
            </div>
        </div>
        <div class="ui-g-12 ui-g-nopad form-buttons">
            <div class="page-buttons mt-30">
                <button pButton type="button" [label]="labelYes" (click)="onDelete()"></button>
            </div>
            <div class="adjust-btn mt-30">
                <button pButton type="button" [label]="labelNo" (click)="onCancel()"></button>
            </div>
        </div>
    </div>
</p-dialog>
